<template>
  <div class="chart-wrapper">
    <MainChartTabs @tabMutated="tabMutated" :defaultTab="defaultTab" />
    <MainChartTips class="top-title" v-show="showTip && titleData.length" :titleData="titleData"
      :isLikeMin1="isLikeMin1" />
    <div class="chart-section" v-show="klineType != 'VALUE'">
      <div class="left" :class="{ 'left-full': !showRight }">
        <MainChartSubTips v-show="!isLikeMin1" :show="showTip" class="sub-title" :tick="subTitleData" />
        <img class="icon" src="../../../assets/icon-chart-logo.png" alt="">
        <div class="main-chart-top" @touchstart="touchStart($event, 'topChart')"
          @touchmove="touchMove($event, 'topChart')" @touchend="touchEnd($event, 'topChart')"
          :class="{ 'top-full': !isLikeMin1 }" id="main-chart-top">
        </div>

        <!-- 增加快手搜索的 AI 顶底内容 -->
        <div class="ai-box" v-if="isKuaishouSearch && klineType === 'MIN1'">
          <div class="ai-chart" id="aiChart">
          </div>
          <div class="tipTop">高位区</div>
          <div class="tipBottom">低位区</div>
          <div class="lock" @click="aiClick" :style="lockStyle">
            <img class="lockImg" :src="lockImgUrl || require('@/assets/lock.gif')"/>
          </div>
        </div>

        <template>
          <MainChartIndicators class="indicators" v-show="!isLikeMin1" @indicatorMutated="indicatorMutated" />
          <MainChartSubTips :show="showTip" tipType="bottom" class="sub-title bottom-title" :tick="bottomTitleData" v-show="!(isKuaishouSearch && klineType === 'MIN1')" />
          <div class="main-chart-bottom" @touchstart="touchStart($event, 'bottomChart')"
            @touchmove="touchMove($event, 'bottomChart')" @touchend="touchEnd($event, 'bottomChart')"
            :class="{ 'bottom-full': !isLikeMin1 }" id="main-chart-bottom" v-show="!(isKuaishouSearch && klineType === 'MIN1')">
          </div>
        </template>
      </div>
      <div class="right" v-show="showRight">
        <ChartPanel />
      </div>
    </div>
    <div class="chart-section" v-show="klineType == 'VALUE'">
      <div class="left left-full">
        <img class="icon" src="../../../assets/icon-chart-logo.png" alt="">
        <div class="main-chart-value" id="main-chart-value" @touchstart="touchStart($event, 'valueChart')"
          @touchmove="touchMove($event, 'valueChart')" @touchend="touchEnd($event, 'valueChart')">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import echarts from 'echarts'
import MainChartTabs from './MainChartTabs'
import MainChartTips from './MainChartTips'
import MainChartSubTips from './MainChartSubTips'
import MainChartIndicators from './MainChartIndicators'
import ChartPanel from './ChartPanel/index.vue'
import { getKlineByHttp, getEtfHistory, getMultipleIndex, getActivity } from '@/api'
import { ws } from '@/websocket'
import ScTrack from '@/utils/track'
const last = require('lodash/last')
const unitUtils = require('@/utils/formatUnit')
import charts from '@/utils/chart/index'
import config from '@/utils/chart/config'
import getBstockConfig from '@/utils/getBstockConfig'
import { isKuaishouSearch } from '@/utils/kuaishouQuery'
let usIndexSymbol = ['QQQ', 'DIA', 'SPY']
export default {
  props: {
    defaultTab: {
      type: String,
      default: 'MIN1'
    }
  },
  data() {
    return {
      lockImgUrl: '',
      lockLinkUrl: '',
      lockTitle: '',
      aiChart: null,
      aiLens: 0,
      MIN1Time: null,
      titleData: [
        // {title: '', value: '', className: ''}
      ],
      subTitleData: [
        // {title: 'MA5', value: 1.23, color: ''}
        // {title: 'MA5', value: 1.23, color: ''},
      ],
      bottomTitleData: [],
      showTip: false,
      tradingKlines: config.tradingKlines,
      klineType: this.defaultTab,
      techType: 'v',
      init: false,
      dataSet: {},
      klineDataInit: false,
      // if realKlineType is not null, klineType convert to realKlineType after handle data
      realKlineType: null,
      klineStack: [],
      pendingType: {},
      topOptions: {
        grid: {
          top: 15,
          left: 0,
          bottom: 21,
          right: 0
        }
      },
    }
  },
  computed: {
    ...mapState(['code', 'market', 'statistic', 'dyna', 'profile', 'region', 'isIndex']),
    isKuaishouSearch() {
      return isKuaishouSearch(this.$route.query)
    },
    showRight() {
      return !this.isIndex && this.klineType === 'MIN1'
    },
    isLikeMin1() {
      return config.tradingKlines.includes(this.klineType)
    },
    isETF() {
      return !!~this.market.toLowerCase().indexOf('etf')
    },
    lockStyle() {
      if (this.klineType === 'MIN1') {
        const h = new Date().getHours()
        const len = this.aiLens || (this.dataSet.MIN1 && this.dataSet.MIN1.c ? this.dataSet.MIN1.c.length : 0)
        if (h < 10 || len <= 0) {
          return { width: '100%' }
        } else {
          // Logic from example: width shrinks as data grows. 
          // Example used (240 - len) * 2 for 480px width.
          // We use percentage to adapt to container width: (240 - len) / 240 * 100%
          const pct = (240 - len) / 240 * 100
          return { width: (pct > 0 ? pct : 0) + '%', minWidth: '75px' }
        }
      }
      return { width: '100%' }
    }
  },
  watch: {
    showTip(val) {
      if (!val) {
        document.querySelector('#app').removeEventListener('touchmove', this.forbiddenScroll, false)
        this.resetTitle()
        if (this.klineType == 'VALUE') {
          this.handleTip({ show: val, peer: 'valueChart' })
        } else {
          this.handleTip({ show: val })
        }
      } else {
        document.querySelector('#app').addEventListener('touchmove', this.forbiddenScroll, false)
      }
    },
    isKuaishouSearch: {
      async handler(val) {
        if (val) {
          await this.fetchLockActivity()
          this.trackExposure()
        }
        this.handleAIChart()
      },
      immediate: true
    },
    klineType() {
      this.handleAIChart()
    }
  },
  created() {
    this.initRegion()
  },
  activated() {

  },
  deactivated() { // 缓存解除绑定
    this.handleKlineStack(0)
    this.handleWSListeners('removeListener')
    ws.websocket.removeListener('onMINKL', this.cbKline)
    ws.websocket.removeListener('onKLINE', this.cbPeriodKline)
  },
  mounted() {
    this.stock = {
      code: this.code,
      market: this.market
    }
    this.handleWSListeners('on')
    this.initDataSet(this.klineType)
    this.initData()
    this.topChart = echarts.init(
      document.getElementById(`main-chart-top`)
    )
    this.bottomChart = echarts.init(
      document.getElementById(`main-chart-bottom`)
    )
    if (this.isETF) {
      this.valueChart = echarts.init(
        document.getElementById(`main-chart-value`)
      )
    }
  },
  beforeDestroy() {
    console.log('onKLINE解绑啦')
    this.handleKlineStack(0)
    this.handleWSListeners('removeListener')
    ws.websocket.removeListener('onMINKL', this.cbKline)
    ws.websocket.removeListener('onKLINE', this.cbPeriodKline)
  },
  components: {
    MainChartTabs,
    MainChartIndicators,
    MainChartTips,
    MainChartSubTips,
    ChartPanel
  },
  methods: {
    initRegion() {
      this.klines = config.klines(this.region)
      this.MIN1Time = charts.tradingTime.create(this.region)
      // this.regionConfig = config.region[this.region];
      this.regionConfig = getBstockConfig(this.code, this.region);
    },
    initDataSet(key) {
      this.$set(this.dataSet, key, {
        t: [],
        h: [],
        o: [],
        l: [],
        c: [],
        v: [],
        a: [],
        avg: [],
        totalAmount: 0,
        totalVol: 0
      })
      if (key !== 'MIN1' && !this.dataSet['MIN1']) {
        this.$set(this.dataSet, 'MIN1', {
          t: [],
          h: [],
          o: [],
          l: [],
          c: [],
          v: [],
          a: [],
          avg: [],
          totalAmount: 0,
          totalVol: 0
        })
      }
    },
    initData(st) {
      console.log('打印中======', this.klineType)
      if (this.klineType === 'MIN1') {
        this.getKlineByWS()
      } else if (this.klineType === 'DAY') {
        this.getPeriodKlineByWS()
      } else if (this.klineType != 'VALUE') {
        this.getKlineByHttp(st)
      } else {
        this.getEtfStockHistory()
      }
    },
    async getEtfStockHistory() {
      const params = {
        symbol: this.code,
        market: this.market,
        date: '2010-01-01'
      }
      const res = await getEtfHistory(params)
      const c = res.map(v => v.unitNV)
      const t = res.map(v => v.tradingDay.slice(0, 10))
      const data = this.dataSet.VALUE
      data.c = c
      data.t = t
      console.log(this.dataSet)
      this.renderValueChart()
    },
    getPeriodKlineByWS() {
      const { code, market } = this.stock
      let oldKlineType = this.oldKlineType = this.klineType
      ws.websocket.safeUnsubscribeKLINE(code, market, this.klineType, this.klines[oldKlineType].limit + 1)
      ws.websocket.safeSubscribeKLINE(code, market, this.klineType, this.klines[oldKlineType].limit + 1)
    },
    getKlineByWS() {
      debugger
      console.log('打印this.klineStack==========', this.klineStack)
      this.klineStack.length > 1 && this.handleKlineStack(0)
      this.handleKlineStack(1)
    },
    // 1: into stack, 0: out of stack
    handleKlineStack(flag) {
      console.log('打印当前标识===', flag)
      const { code, market } = this.stock
      let tmpMarket = market
      ws.websocket.safeUnsubscribeMINKL(code, tmpMarket)
      ws.websocket.safeSubscribeMINKL(code, tmpMarket)
      // debugger
      // if(flag) {
      //   this.klineStack.push(this.klineType)
      //   ws.websocket.safeUnsubscribeMINKL(code, tmpMarket)
      // } else {
      //   console.log('订阅====')
      //   let klineType = this.klineStack.pop()
      //   ws.websocket.safeSubscribeMINKL(code, tmpMarket)
      // }
    },
    handleWSListeners(key) {
      ws.websocket[key]('onMINKL', this.cbKline)
      ws.websocket[key]('onKLINE', this.cbPeriodKline)
    },
    async getKlineByHttp(st) {
      let oldKlineType = this.oldKlineType = this.klineType
      if (this.pendingType[oldKlineType]) return
      this.pendingType[oldKlineType] = true
      const myKline = this.klines[oldKlineType]
      const params = {
        endtime: 2524579200,
        inst: this.stock.code,
        limit: -myKline.limit,
        market: this.stock.market,
        servicetype: 'KLINEB',
        starttime: st ? st + 1 : 0,
        resptype: 'JSON',
        period: myKline.period || oldKlineType
      }
      const res = await getKlineByHttp(params)
      delete this.pendingType[oldKlineType]
      if (!res
        || !res.KlineData) {
        return
      }
      if (config.minKlines.includes(this.klineType) && oldKlineType === this.klineType) {
        this.getKlineByWS(res.Period)
      }
      this.handleData(res.KlineData, oldKlineType)
    },
    // 今天的
    cbKline(data) {
      console.log(data, '======cbKline')
      let tmpMarket = data.Market.replace('DELAY_', '')
      if (data.Inst !== this.stock.code || tmpMarket.toLowerCase() !== this.stock.market.toLowerCase()) return
      // if(data.QuoteData.KlineData.length > 1 && this.klineDataInit) return
      // console.log('========cdKline', data)
      this.handleData(data.QuoteData.KlineData, data.Period)
    },
    cbPeriodKline(data) {
      let oldKlineType = this.oldKlineType = this.klineType
      console.log(data, '======cbPeriodKline')
      let tmpMarket = data.Market.replace('DELAY_', '')
      if (data.Inst !== this.stock.code || tmpMarket.toLowerCase() !== this.stock.market.toLowerCase()) return
      // if(data.QuoteData.KlineData.length > 1 && this.klineDataInit) return
      // console.log('========cdKline', data)
      delete this.pendingType[oldKlineType]
      this.handleData(data.QuoteData.KlineData, data.Period)
    },
    handleData(data, klineType) {
      let vm = this
      klineType = klineType || vm.klineType
      let limit = this.klines['MIN1'].limit
      let is5day = klineType === '5-MIN1' && data.length > limit
      let isCombine = klineType === 'MIN1' || klineType === 'DAY'
      let min1Len = this.dataSet['MIN1'].c.length
      let { h, o, l, c, t, v, a, avg, totalAmount, totalVol } = this.dataSet[klineType]
      if (last(t) === last(data).Time) {
        // 防止分钟k线重复
        if (!isCombine) return this.renderCandleChart()
        h.pop()
        o.pop()
        l.pop()
        c.pop()
        t.pop()
        avg.pop()
        totalVol = totalVol - v.pop()
        totalAmount = totalAmount - a.pop()
      }
      data.forEach((el, index) => {
        if (is5day && index % limit === 0) {
          totalAmount = 0
          totalVol = 0
          t.push(el.Time + 1)
          h.push('-')
          o.push('-')
          l.push('-')
          c.push('-')
          v.push('-')
          a.push('-')
          avg.push('-')
        }
        totalAmount += el.Amount
        totalVol += el.Volume
        //console.log('打印中===',el)
        t.push(el.Time)
        h.push(el.High)
        o.push(el.Open)
        l.push(el.Low)
        c.push(el.Close)
        v.push(el.Volume)
        a.push(el.Amount)
        avg.push(charts.formatUnit(totalAmount / totalVol, 0, true, this.regionConfig.precision))
      })
      this.dataSet[klineType].totalAmount = totalAmount
      this.dataSet[klineType].totalVol = totalVol
      this.klineDataInit = true
      if (klineType === 'DAY' && this.realKlineType) {
        this.klineType = this.realKlineType
        this.realKlineType = null
      }
      console.log(this.dataSet)
      if (vm.klineType === 'MIN1') return this.renderMIN1Chart()
      // 特殊的k线，可能需要借用MIN1作为今日数据
      if ((vm.klineType === '1-MIN1' || vm.klineType === '5-MIN1') && klineType !== 'MIN1') return this.borrowMIN1(klineType === 'MIN1', min1Len)
      if (klineType !== 'MIN1' && this.oldKlineType === this.klineType) return this.renderCandleChart()
    },
    borrowMIN1(isTick, len) {
      const vm = this
      let limit = this.klines['MIN1'].limit
      let dataSet = this.dataSet
      let debtor = dataSet[vm.klineType]
      let debtee = dataSet['MIN1']
      // 5日数据真空期
      if (!debtor.t.length && isTick) return
      const next = vm.klineType === '5-MIN1' ? this.renderMIN1Chart : this.renderCandleChart
      if (last(debtor.t) === last(debtee.t) || !debtee.c.length) return next()
      // 5日需要切除第一天数据
      if (!isTick && vm.klineType === '5-MIN1' && debtor.t.length > 4 * limit) {
        debtor.t.splice(0, limit)
        debtor.h.splice(0, limit)
        debtor.o.splice(0, limit)
        debtor.l.splice(0, limit)
        debtor.c.splice(0, limit)
        debtor.v.splice(0, limit)
        debtor.a.splice(0, limit)
        debtor.avg.splice(0, limit)
      }
      if (isTick) {
        debtor.t.splice(-len)
        debtor.h.splice(-len)
        debtor.o.splice(-len)
        debtor.l.splice(-len)
        debtor.c.splice(-len)
        debtor.v.splice(-len)
        debtor.a.splice(-len)
        debtor.avg.splice(-len)
      }
      dataSet[vm.klineType] = {
        t: debtor.t.concat(debtee.t),
        h: debtor.h.concat(debtee.h),
        o: debtor.o.concat(debtee.o),
        l: debtor.l.concat(debtee.l),
        c: debtor.c.concat(debtee.c),
        v: debtor.v.concat(debtee.v),
        a: debtor.a.concat(debtee.a),
        avg: debtor.avg.concat(debtee.avg),
        totalAmount: debtee.totalAmount,
        totalVol: debtee.totalVol
      }
      ; (this.klineType !== 'MIN1' || this.oldKlineType === this.klineType) && next()
    },
    renderValueChart() {
      console.log(charts.Value.option(this))
      this.valueChart.setOption(charts.Value.option(this))
      this.decorateValueCharts()
    },
    renderMIN1Chart() {
      if (!this.isLikeMin1) return
      this.topChart.setOption(charts.MIN1Chart.options(this), true)
      this.renderBottomChart()
    },
    renderCandleChart() {
      if (this.isLikeMin1
        || charts.candle.options(this) === -1) return
      this.topChart.setOption(this.candleOption, true)
      this.renderBottomChart()
    },
    renderBottomChart() {
      charts.bottom.options(this)
      this.bottomChart.setOption(this.bottomOption, true)
      !this.init && this.decorateCharts()
    },
    resetTitle() {
      this.titleData = []
      this.subTitleData = []
      this.bottomTitleData = []
      this.topChart.dispatchAction({
        type: 'updateAxisPointer',
        currTrigger: 'leave'
      })
      this.bottomChart.dispatchAction({
        type: 'updateAxisPointer',
        currTrigger: 'leave'
      })
      this.valueChart.dispatchAction({
        type: 'updateAxisPointer',
        currTrigger: 'leave'
      })
    },
    createTitleData(index, val) {
      let { singleHand, precision } = this.regionConfig
      try {
        const { h, o, l, c, t, avg, v } = this.getMyData()
        let vol = unitUtils.formatUnit(v[index] / singleHand, false, true, 0)
        console.log(111)
        if (this.isLikeMin1) {
          let base = this.statistic.PreClosePrice
          console.log('base', base)
          let className = charts.getColorClass(c[index], base)
          this.titleData = [
            { title: '', value: charts.dateFormat(t[index] * 1000, 'hh:mm') },
            { title: '价', value: c[index].toFixed(precision), className },
            { title: '幅', value: `${(((c[index] - base) / base) * 100).toFixed(2)}%`, className },
            { title: '量', value: vol },
          ]
          !this.isIndex
            && this.titleData.push(
              { title: '均', value: avg[index], className: charts.getColorClass(avg[index], base) }
            )
        } else {
          let base = c[index - 1] || c[index]
          this.titleData = [
            { title: '开', value: o[index].toFixed(precision), className: charts.getColorClass(o[index], base) },
            { title: '高', value: h[index].toFixed(precision), className: charts.getColorClass(h[index], base) },
            { title: '幅', value: `${(((c[index] - base) / base) * 100).toFixed(2)}%`, className: charts.getColorClass(c[index], base) },
            { title: '成交', value: vol },
            { title: '收', value: c[index].toFixed(precision), className: charts.getColorClass(c[index], base) },
            { title: '低', value: l[index].toFixed(precision), className: charts.getColorClass(l[index], base) },
            { title: '额', value: `${((c[index] - base)).toFixed(precision)}`, className: charts.getColorClass(c[index], base) },
          ]
          if (!this.isIndex) {
            let cgr
            if (this.region === 'CN') {
              cgr = (v[index] / this.profile.CircSkamt / 100).toFixed(2)
            } else {
              cgr = (v[index] / this.dyna.TotStock * 100).toFixed(2)
            }
            this.titleData.push(
              { title: '换手', value: isFinite(cgr) ? `${cgr}%` : '-' }
            )
          } else {
            let range = (((h[index] - l[index]) / base) * 100).toFixed(2)
            this.titleData.push(
              { title: '振幅', value: isFinite(range) ? `${range}%` : '-' }
            )
          }
        }
        !this.isLikeMin1 && this.createSubTitleData(val)
          ; (this.techType !== 'v' || this.techType !== 'BOLL')
            && this.createBottomTitle(index)
      } catch (e) { }
    },
    createSubTitleData(val) {
      this.subTitleData = charts.isDef(val)
        ? val.slice(1).map(item => {
          return {
            title: item.seriesName,
            color: item.color,
            className: 'rise-color',
            value: item.value ? item.value.toFixed(this.regionConfig.precision) : '-'
          }
        })
        : []
    },
    createBottomTitle(index) {
      this.bottomTitleData = charts.isDef(this.bottomRawData) && charts.isDef(index)
        ? this.bottomRawData.map(item => {
          return {
            title: item.name,
            value: unitUtils.formatUnit(item.data[index]),
            color: item.color
          }
        })
        : []
    },
    getMyData() {
      return this.dataSet[this.klineType]
    },
    decorateValueCharts() {
      this.oldAxisLabelDistance = 0
      this.valueChart.on('datazoom', obj => {
        const { start, end } = obj.batch[0]
        let newAxisLabelDistance = end - start
        const myData = this.getMyData()
        if (this.oldAxisLabelDistance !== newAxisLabelDistance) {
          this.oldAxisLabelDistance = newAxisLabelDistance
          this.valueChart.setOption({
            xAxis: {
              axisLabel: {
                interval: parseInt((newAxisLabelDistance) / 250 * myData.t.length)
              }
            }
          })
        }
      })
    },
    decorateCharts() {
      this.init = true
      this.oldAxisLabelDistance = 0
      this.topChart.on('datazoom', obj => {
        if (this.isLikeMin1) return
        const { start, end } = obj.batch[0]
        let newAxisLabelDistance = end - start
        const myData = this.getMyData()
        if (this.oldAxisLabelDistance !== newAxisLabelDistance) {
          this.oldAxisLabelDistance = newAxisLabelDistance
          this.topChart.setOption({
            xAxis: {
              axisLabel: {
                interval: parseInt((newAxisLabelDistance) / 250 * myData.t.length)
              }
            }
          })
        }
        this.bottomChart.dispatchAction({
          type: 'dataZoom',
          batch: [{
            start,
            end
          }]
        })
      })
      charts.connectCharts([this.topChart, this.bottomChart])
    },
    cacheUsable(type) {
      return this.dataSet[type] && this.dataSet[type].t.length > 0
    },
    tabMutated(val) {
      if (this.klineType === val) return
      this.$nextTick(() => {
        this.topChart.resize()
        this.bottomChart.resize()
      })
      this.showTip = false
      const useCache = this.cacheUsable(val)
      // !useCache && this.initDataSet(val)
      this.klineDataInit = useCache
      this.klineType = val
      if (useCache) {
        this.isLikeMin1 ? this.renderMIN1Chart() : this.renderCandleChart()
      } else {
        this.initDataSet(val)
        this.initData()
      }
    },
    indicatorMutated(val) {
      // BOLL is belongs to top chart
      let renderCandle = this.techType === 'BOLL' || val === 'BOLL'
      this.techType = val
      renderCandle && this.renderCandleChart()
      this.renderBottomChart()
    },
    handleTip({ peer = 'topChart', show, x, y, isMoving }) {
      // throttle is useable
      // console.log(x && x.toFixed(1), y && y.toFixed(1))
      show && this[peer].dispatchAction({ type: `showTip`, x, y })
      !this.isLikeMin1 && !isMoving && this[peer].setOption({
        dataZoom: {
          disabled: show
        }
      })
    },
    forbiddenScroll(e) {
      e.preventDefault()
    },
    touchStart(e, peer) {
      this.showTip = false
      this.removeIfTimer()
      this.timer = setTimeout(() => {
        this.showTip = true
        this.handleTip({ show: true, peer, x: e.zrX, y: e.zrY })
      }, 300)
    },
    touchMove(e, peer) {
      if (!this.showTip) return this.touchEnd()
      this.handleTip({ show: true, peer, x: e.zrX, y: e.zrY, isMoving: true })
    },
    touchEnd() {
      this.removeIfTimer()
      this.timer = this.showTip ? setTimeout(() => {
        this.showTip = false
      }, 5000) : null
    },
    removeIfTimer() {
      this.timer && clearTimeout(this.timer)
    },
    async fetchLockActivity() {
      try {
        const res = await getActivity({
            position: '9fztgw_ks_ad2',
            activityStatus: 'NOW',
            hiddenStatus: 'SHOWN'
        })
        if (res && res.list && res.list.length > 0) {
            const activity = res.list[0]
            this.lockImgUrl = activity.image
            this.lockLinkUrl = activity.link || ''
            this.lockTitle = activity.title || ''
        }
      } catch(e) {
        console.error(e)
      }
    },
    aiClick() {
      console.log('aiClick')
      // 埋点-点击
      ScTrack.getInstance().track('exposure_ad', {
        position_id: '9fztgw_ks_ad2',
        material_title: this.lockTitle,
        material_url: this.lockLinkUrl
      })
      window.open(`https://s.techgp.cn/6l53bZ`);
    },
    trackExposure() {
       // 埋点-展示
       this.$nextTick(() => {
          ScTrack.getInstance().track('exposure_ad_show', {
              position_id: '9fztgw_ks_ad2',
              material_title: this.lockTitle,
              material_url: this.lockLinkUrl
          })
       })
    },
    handleAIChart() {
      if (this.isKuaishouSearch && this.isLikeMin1) {
        this.$nextTick(() => {
          this.renderAIChart()
        })
      }
    },
    async renderAIChart() {
      if (!this.isKuaishouSearch || !this.isLikeMin1) return
      const params = {
        market: this.market,
        symbol: this.code,
        dataKey: 'aidd',
        adjusting: 1,
        period: 13
      }
      try {
        const res = await getMultipleIndex(params)
        if (!res || !Array.isArray(res)) return
        
        res.splice(0, 30)
        this.aiLens = res.length
        const list = charts.tradingTime.create(this.region) // ['09:30', ...]
        // Create 242 points mock
        let ret = new Array(242).fill({})
        const todayStr = new Date().toISOString().slice(0, 10) // YYYY-MM-DD
        
        ret = ret.map((item, index) => {
           const t = list[index] || ''
           return {
             aiddTimestamp: t // Simplified, just use time string or construct timestamp if needed
           }
        })
        
        ret.splice(0, res.length - 1, ...res.reverse())
        
        const data = ret.map((item, index) => {
           return item.indexValue !== undefined && item.indexValue !== null ? Number(item.indexValue.toFixed(2)) : null
        })

        const highBaseData = data.map(v => v === null ? null : 75)
        const highDiffData = data.map(v => v === null ? null : (v > 75 ? v - 75 : 0))
        const lowBaseData = data.map(v => v === null ? null : (v < 25 ? v : 25))
        const lowDiffData = data.map(v => v === null ? null : (v < 25 ? 25 - v : 0))
        
        // Render chart
        const dom = document.getElementById('aiChart')
        if (!dom) return
        if (this.aiChart) {
           this.aiChart.dispose()
           this.aiChart = null
        }
        this.aiChart = echarts.init(dom)
        
        const option = {
           grid: {
             top: 5, bottom: 5, left: 0, right: 0
           },
           xAxis: {
             type: 'category',
             show: false,
             data: list // Use trading time as categories
           },
           yAxis: {
             type: 'value',
             min: 0,
             max: 100,
             show: false
           },
           series: [
            // Main Blue Line
            {
             type: 'line',
             smooth: true,
             symbol: 'none',
             lineStyle: {
                width: 1,
                color: '#196DFF'
             },
             data: data,
             z: 10,
             markLine: {
                symbol: 'none',
                silent: true,
                data: [
                    { yAxis: 75, lineStyle: { type: 'dashed', color: '#00B578' }, label: { show: false } },
                    { yAxis: 25, lineStyle: { type: 'dashed', color: '#FA5151' }, label: { show: false } }
                ]
             }
           },
           // High Area Fill (Stack)
           {
             type: 'line',
             smooth: true,
             symbol: 'none',
             lineStyle: { width: 0, opacity: 0 },
             data: highBaseData,
             stack: 'high',
             silent: true,
             showSymbol: false
           },
           {
             type: 'line',
             smooth: true,
             symbol: 'none',
             lineStyle: { width: 0, opacity: 0 },
             areaStyle: {
                color: 'rgba(0, 181, 120, 0.3)' // Green
             },
             data: highDiffData,
             stack: 'high',
             silent: true,
             showSymbol: false
           },
           // Low Area Fill (Stack)
           {
             type: 'line',
             smooth: true,
             symbol: 'none',
             lineStyle: { width: 0, opacity: 0 },
             data: lowBaseData,
             stack: 'low',
             silent: true,
             showSymbol: false
           },
           {
             type: 'line',
             smooth: true,
             symbol: 'none',
             lineStyle: { width: 0, opacity: 0 },
             areaStyle: {
                color: 'rgba(250, 81, 81, 0.3)' // Red
             },
             data: lowDiffData,
             stack: 'low',
             silent: true,
             showSymbol: false
           }
          ]
        }
        this.aiChart.setOption(option)
        
      } catch(e) {
        console.error(e)
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.chart-wrapper
  margin-top .06rem
  height 3.65rem
  position relative

.top-title
  position absolute
  top 0
  z-index 11
  height .39rem
  background-color #FAFAFA
  width 100%

.sub-title
  height .14rem

.bottom-title
  position absolute
  right 0

.chart-section
  display flex
  height 3.25rem
  background-color white
  padding 0 .05rem
  .left
    margin .05rem 0 0
    width 2.6rem
    border 1px solid #f5f5f5
    position relative
    .icon
      height .17rem
      width .8rem
      position absolute
      left .9rem
  .left-full
    width 3.65rem
    .icon
      top 0rem
      left 1.42rem !important
  .right
    width 1.05rem

.main-chart-top {
  width 100%
  height: 2.55rem
}
.main-chart-bottom {
  width 100%
  height: .59rem
  border-top 0.01rem solid #f5f5f5
}
.main-chart-value
  width 3.65rem
  height 3.1rem
.top-full
  height: 2.14rem
.bottom-full
  height .68rem
.indicators
  height: .24rem

.ai-box
  position relative
  height .68rem // Match bottom-full height approx or adjust
  width 100%
  border-top 1px solid #f5f5f5
  // background #f9f9f9
  

.ai-chart
  width 100%
  height 100%
  background url('~@/assets/ai-chart-bg.png') no-repeat center center
  background-size cover

.tipTop
  position absolute
  top 5px
  left 50%
  transform translateX(-50%)
  font-size 9px
  color #fff
  background rgba(28, 183, 123, 0.7)
  padding 1px 4px
  border-radius 2px

.tipBottom
  position absolute
  bottom 2px
  left 50%
  transform translateX(-50%)
  font-size 9px
  color #fff
  background rgba(233, 48, 48, 0.7)
  padding 1px 4px
  border-radius 2px

.lock
  position absolute
  right 0
  top 0
  width 100px
  height 100%
  display flex
  flex-direction column
  align-items center
  justify-content center
  font-size 12px
  color #666
  z-index 10
  background-color: #FCEAD3;

.lockImg
  width 64px
  height 64px
  object-fit cover

.lockText
  color #6d3d29
  font-size 12px
  font-weight 480
</style>